export const GET_LIGHT_MODE_REQUEST = "GET_LIGHT_MODE_REQUEST";
export const GET_LIGHT_MODE_SUCCESS = "GET_LIGHT_MODE_SUCCESS";
export const GET_LIGHT_MODE_FAILURE = "GET_LIGHT_MODE_FAILURE";

export const SET_LIGHT_MODE_REQUEST = "SET_LIGHT_MODE_REQUEST";
export const SET_LIGHT_MODE_SUCCESS = "SET_LIGHT_MODE_SUCCESS";
export const SET_LIGHT_MODE_FAILURE = "SET_LIGHT_MODE_FAILURE";